import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-zone"
}
const _hoisted_2 = { class: "user-intro" }
const _hoisted_3 = { class: "user-name" }

import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheUserZone',
  setup(__props) {

const store = useStore<AppStore>();
const user = computed(() => store.state.authenticatedUser);

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("span", null, [
            _createTextVNode("Välkommen")
          ])), [
            [_directive_translate]
          ]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(user.value.name), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})